export class SchoolMemo {
    constructor(
        public comment: string,
        public id?: number | null
    ){}
}
